// @ts-nocheck

export type TicketListWithOcAssignee = typeof TicketListWithOcAssignee[keyof typeof TicketListWithOcAssignee];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketListWithOcAssignee = {
  true: 'true',
  false: 'false',
} as const;
